import { Component, OnDestroy, OnInit } from '@angular/core';
import { DataTableEventsService } from 'src/app/main/shared/table/common/services/datatable.events.service';
import { isNullOrUndefined } from '@swimlane/ngx-datatable';
import { Subscription, generate } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseLevelColumnConfig, accuracyDatabaseTableConfiguration } from 'src/app/main/side-bar/heat-index/heatwave/accuracy-table-data.config.cnst';
import { HeatIndexDataService } from 'src/app/main/side-bar/heat-index/heat-index-data.service';
import { resolve } from 'url';
import { UtilsService } from 'src/app/utils/utils.service';
import { data } from 'jquery';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { HeatwaveDataService } from '../../side-bar/heat-watch/heatwave/heatwave-data.service';

@Component({
  selector: 'app-accuracy-popup-data-table',
  templateUrl: './accuracy-popup-data-table.component.html',
  styleUrls: ['./accuracy-popup-data-table.component.scss']
})
export class AccuracyPopupDataTableComponent implements OnInit, OnDestroy {

  accuracyDatabaseTableConfig: {
    options: any,
    data: any[],
    id: any,
    visible: boolean,
    spinner: boolean
  } = {
      options: this.dataService.deepClone(accuracyDatabaseTableConfiguration),
      data: [],
      id: 'accuracy data table',
      visible: false,
      spinner: true
    };
  forecastTableData: any = [];
  // heatwatchTableData: any = [];
  accuracyTableData: any = [];
  subscriptions: Subscription[] = [];
  breadCrumbParams: any[] = [];
  forecastList: any = [];
  heatWatchesCount: any;
  hwAccuracyData: any;
  inputForBreadcrumb: any = [];
  districtName: String;
  countryName: String = "India";
  stateUUID: any;
  selectedState:any;
  districtUUID: any;
  stateName: String;
  mandalName: String;
  locType: any;
  actualTemperatureTableData: any = [];
  actualTemperatureData: any[];
  selectedSource: any = 'IMD';
  queryParams:any;

  constructor(private dataService: HeatwaveDataService,
    private tableEventsHandler: DataTableEventsService,
    public router: Router,
    private route: ActivatedRoute,
    private utils: UtilsService,
    private expandmodal: NgbActiveModal,
  ) {

  }

  ngOnInit(): void {
    // this.utils.setHeatWaveSource.subscribe(async data => {
    //   if (isNullOrUndefined(data) || data == 'IMD_LONG_RANGE') {
    //     this.selectedSource = 'IMD';
    //   } else {
        this.selectedSource = this.queryParams['source'] != 'ECMWF' ? 'IMD' : 'ECMWF';
    //   }
    // })
    this.tableEventsHandler.addInitSubject(this.accuracyDatabaseTableConfig.id);
    this.subscribeTableEvents();
    this.locType = this.dataService.toTitleCase(this.locType)
    if (this.locType == 'Country') {
      this.breadCrumbClick(this.locType, this.countryName);
    } else if (this.locType == 'State' || this.locType == 'District') {
      this.locType = 'State'
      this.breadCrumbClick(this.locType, this.selectedState);
    }
  }
  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }
  async initMethod(postData: any) {
    this.forecastTableData = await this.getForecastData(postData);
    // this.heatwatchTableData = await this.getHeatWatchesCount(postData);
    this.actualTemperatureTableData = await this.getActualTemperatureData(postData);
    this.accuracyTableData = await this.getHWAccuracyData(postData);
    this.accuracyDatabaseTableConfig.options.columns = this.dataService.deepClone(BaseLevelColumnConfig);
    this.accuracyDatabaseTableConfig.data = this.mergeAllData(this.forecastTableData,this.actualTemperatureTableData,this.accuracyTableData);
    this.accuracyDatabaseTableConfig.options.columns[0].name = this.locType == 'Country' ? 'State' : 'District';
    this.accuracyDatabaseTableConfig.options.columns[0].dataType = this.locType == 'State' ? 'TEXT' : 'LOCATION';
    this.accuracyDatabaseTableConfig.visible = true;
    this.accuracyDatabaseTableConfig.spinner = false;

  }

  mergeAllData(forecastData: any[], accuracyData: any[], actualTemperatureData: any[]): any[] {
    let mergedData: any = [];
    const dict1 = forecastData.reduce((acc, item) => {
      acc[item.uuid] = item;
      return acc;
    }, {});

    const dict2 = accuracyData.reduce((acc, item) => {
      acc[item.uuid] = item;
      return acc;
    }, {});

    const dict3 = actualTemperatureData.reduce((acc, item) => {
      acc[item.uuid] = item;
      return acc;
    }, {});

    const allUuids = new Set([...Object.keys(dict1), ...Object.keys(dict2), ...Object.keys(dict3)]);

    mergedData = Array.from(allUuids).map(uuid => {
      return { ...dict1[uuid], ...dict2[uuid], ...dict3[uuid] };
    });
    return mergedData;
  }

  /**
  * Subscribe to the initialization subject for a specific table configuration
  */

  subscribeTableEvents() {
    this.tableEventsHandler.initSubject[this.accuracyDatabaseTableConfig.id].subscribe(s => {
      if (!isNullOrUndefined(this.accuracyDatabaseTableConfig.id) && !isNullOrUndefined(this.tableEventsHandler.dataTableConfigSubjects[this.accuracyDatabaseTableConfig.id])) {
        const breadcrumbSub = this.tableEventsHandler.dataTableConfigSubjects[this.accuracyDatabaseTableConfig.id]['breadcrumbClicked'].subscribe(s => {
          // this.tablebreadcrumbClick(s);
        });
        this.subscriptions.push(breadcrumbSub);
      }
    });
  }
  // tablebreadcrumbClick(data: any) {
  //   this.router.navigate(['.'], {
  //     relativeTo: this.route,
  //     queryParamsHandling: 'merge',
  //   });
  //   this.accuracyDatabaseTableConfig.options['columns'][0].name = data.child;
  // }
  getForecastData(data: any) {
    const today = new Date();
    const startTs = today.getTime() - (7 * 24 * 60 * 60 * 1000);
    const endTs = today.getTime();
    const morning830 = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 8, 30);
    const subTimePeriod = morning830.getTime();
    const postData = {
      "component": "HEATWAVE",
      "sUUID": data.sUUID,
      "pUUID": data.pUUID,
      "pType": data.pType,
      "cType": data.cType,
      "source": this.selectedSource == 'IMD' ? "IMD_LONG_RANGE" : this.selectedSource,
      "startTs": startTs,
      "endTs": endTs,
      "subTimePeriod": subTimePeriod
      // "startTs": 1715644800000,
      // "endTs": 1716163200000,
      // "subTimePeriod": 1716163200000
    };

    return new Promise((resolve, reject) => {
      this.accuracyDatabaseTableConfig.spinner = true;
      this.dataService.getForecastData(postData).subscribe(
        (response) => {
          // console.log(response, "response 999");
          this.forecastList = response;
          // console.log(this.forecastList, "api response 999");

          resolve(this.flattenForecastData(this.forecastList));
          this.accuracyDatabaseTableConfig.spinner = false;
          // console.log("Flattened Forecast Data:999", this.forecastTableData);
        }
      );
    })
  }
  flattenForecastData(forecastList: any[]): any[] {
    let flattenedData = [];
    forecastList.forEach(item => {
      let rowData = {
        name: item.name,
        uuid: item.uuid
      };
      item.table_data.forEach((dataPoint, index) => {
        // rowData[`timeStamp${index + 1}`] = dataPoint.data;
        rowData[`timeStamp${index + 1}`] = Number(dataPoint.data).toFixed(1);
      });
      flattenedData.push(rowData);
    });
    return flattenedData;
  }
  getActualTemperatureData(data: any) {
  //   const postData = {
  //     "component": "HEATWAVE",
  //     "sUUID": "00cb31c7-2928-4e6d-adcc-443d478c90d6",
  //     "pUUID": "00cb31c7-2928-4e6d-adcc-443d478c90d6",
  //     "pType": "COUNTRY",
  //     "cType": "STATE",
  //     "subTimePeriod": "20240624"
  //   };
    const currentDate = new Date();
    const currentHour = currentDate.getHours();
    const currentMinutes = currentDate.getMinutes();

    let displayDate;

    if (currentHour > 17 || (currentHour === 17 && currentMinutes >= 30)) {
      // After 5:30 PM
      displayDate = currentDate;
    } else {
      // Before 5:30 PM
      const yesterday = new Date(currentDate);
      yesterday.setDate(currentDate.getDate() - 1); // Set date to yesterday
      displayDate = yesterday;
    }
    const formattedDate = displayDate.toISOString().slice(0, 10).replace(/-/g, ""); // Format date as YYYYMMDD
    // const formattedDate = Math.floor(displayDate.getTime() / 1000) * 1000; // Convert date to Unix timestamp in milliseconds
    const postData = {
      "component": "HEATWAVE",
      "sUUID": data.sUUID,
      "pUUID": data.pUUID,
      "pType": data.pType,
      "cType": data.cType,
      "subTimePeriod": formattedDate // Use formatted date for subTimePeriod
    };

    this.accuracyDatabaseTableConfig.spinner = true;

    return new Promise((resolve, reject) => {
      this.accuracyDatabaseTableConfig.spinner = true;
      this.dataService.getActualTemperatureData(postData).subscribe(
        (response) => {
          this.actualTemperatureData = response;
          resolve(this.flattenActualTemperatureData(this.actualTemperatureData));
          this.accuracyDatabaseTableConfig.spinner = false;

        }
      );
    });
  }
  flattenActualTemperatureData(actualTemperatureData: any[]): any[] {
    
    const flattenedData = [];

    actualTemperatureData.forEach(item => {
      const rowData = {
        name: item.name,
        uuid: item.uuid
      };
      item.table_data.forEach((dataPoint, index) => {
        rowData[`actualtimeStamp${index + 1}`] = Number(dataPoint.data).toFixed(1); 
      });
      flattenedData.push(rowData);
    });

    return flattenedData;
  }
  getHWAccuracyData(data: any) {
    let selected;
    if(this.selectedSource == 'IMD_LONG_RANGE'){
      selected = 'IMD'
    } else if(this.selectedSource == 'ECMWF'){
      selected = 'ECMWF'
    }   
    // Get the current date and time
    const now = new Date();

    // Determine endTs based on the current time
    let endTs;
    if (now.getHours() > 17 || (now.getHours() === 17 && now.getMinutes() >= 30)) {
        // After 5:30 PM, set endTs to today's date at 8:30 AM
        const today = new Date(now);
        today.setHours(8, 30, 0, 0);
        endTs = today.getTime();
    } else {
        // Before 5:30 PM, set endTs to yesterday's date at 8:30 AM
        const yesterday = new Date(now);
        yesterday.setDate(now.getDate() - 1);
        yesterday.setHours(8, 30, 0, 0);
        endTs = yesterday.getTime();
    }

    // Calculate startTs similarly based on the time
    let startTs;
    if (now.getHours() > 17 || (now.getHours() === 17 && now.getMinutes() >= 30)) {
        // After 5:30 PM, set startTs to 9 days before today's date at 8:30 AM
        const startDate = new Date(endTs);
        startDate.setDate(startDate.getDate() - 9);
        startDate.setHours(8, 30, 0, 0);
        startTs = startDate.getTime();
    } else {
        // Before 5:30 PM, set startTs to 9 days before yesterday's date at 8:30 AM
        const startDate = new Date(endTs);
        startDate.setDate(startDate.getDate() - 8);
        startDate.setHours(8, 30, 0, 0);
        startTs = startDate.getTime();
    }

    const postData = {
        "component": "HEATWAVE",
        "sUUID": data.sUUID,
        "pUUID": data.pUUID,
        "timePeriod": "LASTKNOWN",
        "pType": data.pType,
        "cType": data.cType,
        "sourceType": selected || "IMD",
        "startTs": startTs,
        "endTs": endTs
    };
    return new Promise((resolve, reject) => {
      this.accuracyDatabaseTableConfig.spinner = true;
      this.accuracyDatabaseTableConfig.spinner = true;
      this.dataService.getAccuracyData(postData).subscribe(
        (response) => {
          this.hwAccuracyData = response;
          // console.log("HW Accuracy Data:666", this.hwAccuracyData);

          // Transform and bind data
          resolve(this.flattenHWAccuracyData(this.hwAccuracyData));
          this.accuracyDatabaseTableConfig.spinner = false;
          // console.log("Flattened HW Accuracy Data:666", this.accuracyTableData);
        }
      );
    })
  }
  flattenHWAccuracyData(hwAccuracyData: any[]): any[] {
    const flattenedData = [];

    hwAccuracyData.forEach(item => {
      const rowData = {
        name: item.name,
        uuid: item.uuid
      };
      item.table_data.forEach((dataPoint, index) => {
        // console.log(dataPoint.data, "123 data");
        rowData[`accuracy_timeStamp${index + 1}`] = (dataPoint.data.accuracy * 100);
        // console.log(rowData[`accuracy_timeStamp${index + 1}`], "123 row data")
      });
      flattenedData.push(rowData);
    });

    return flattenedData;
  }

  breadCrumbClick(type: any, locName: any) {
    this.locType = type;
    const hierarchy: any = ["Country", "State", "District", "Mandal"];
    let nextLocType = hierarchy[hierarchy.indexOf(type) + 1];
    if (type == 'Country') {
      this.countryName = locName;
      this.stateName = ''
      this.districtName = ''
      this.mandalName = ''
      let postData: any = {
        "sUUID": "00cb31c7-2928-4e6d-adcc-443d478c90d6",
        "pUUID": "00cb31c7-2928-4e6d-adcc-443d478c90d6",
        "pType": "COUNTRY", // parent
        "cType": "STATE", // child
        "countLocationType": "DISTRICT" // subchild 
      };
      this.initMethod(postData);
    } else if (type == 'State') {
      this.stateName = locName;
      this.districtName = ''
      this.mandalName = ''
      this.stateName = locName;
      let postData: any = {
        "sUUID": this.stateUUID,
        "pUUID": this.stateUUID,
        "pType": "STATE", // parent
        "cType": "DISTRICT", // child
        "countLocationType": "BLOCK" // subchild 
      };
      this.initMethod(postData);
    }    
    // this.accuracyDatabaseTableConfig.options.columns[0].name = nextLocType;
    
    this.accuracyDatabaseTableConfig.options.columns = nextLocType;
  }

  tableRowClick(rowData: any, locType: any) {
    const hierarchy: any = ["Country", "State", "District", "Mandal"];
    this.locType = hierarchy[hierarchy.indexOf(locType) + 1];
    this.accuracyDatabaseTableConfig.options.columns[0].name = locType;
    if (this.locType == "State") {
      this.stateName = rowData['values'][0];
      this.stateUUID = rowData['values'][1];
      this.districtName = "";
      this.mandalName = "";
      let postData: any = {
        "sUUID": rowData['values'][1],
        "pUUID": rowData['values'][1],
        "pType": "STATE", // parent
        "cType": "DISTRICT", // child
        "countLocationType": "BLOCK" // subchild 
      };
      this.initMethod(postData);
    } else if (this.locType == "District") {
      this.districtName = rowData['values'][0];
      this.districtUUID = rowData['values'][1];
      this.mandalName = '';
      let postData: any = {
        "sUUID": rowData['values'][1],
        "pUUID": rowData['values'][1],
        "pType": "DISTRICT", // parent
        "cType": "BLOCK", // child
        "countLocationType": "COUNTRY" // subchild 
      };
      this.initMethod(postData);
    } else if (this.locType == "Mandal") {
      this.mandalName = rowData['values'][0];
      let postData: any = {
        "sUUID": rowData['values'][1],
        "pUUID": rowData['values'][1],
        "pType": "BLOCK", // parent
        "cType": "COUNTRY", // child
        "countLocationType": "COUNTRY" // subchild 
      };
      this.initMethod(postData);
    }
  }
  closeModal() {
    this.expandmodal.dismiss()
  }
}
